import { useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { isDigitOnlyString } from "@utils/helpers"
import { MAX_FILTER_JAN_CODE_LENGTH, SORT_DIRECTION } from "@constants"
import { ProductListFilter } from "@/types"

function parseProductListFilter(searchParams: URLSearchParams) {
  const params = Object.fromEntries(searchParams.entries().filter(([_, value]) => isDigitOnlyString(value)))

  const filterParams: ProductListFilter = {}

  if (params.page) filterParams.page = Number(params.page)

  if (params.per_page) filterParams.per_page = Number(params.per_page)

  if (params.maker_id) filterParams.maker_id = Number(params.maker_id)

  if (params.tag_id) filterParams.tag_id = Number(params.tag_id)

  if (params.jan_code) {
    filterParams.jan_code =
      params.jan_code.length > MAX_FILTER_JAN_CODE_LENGTH
        ? params.jan_code.slice(0, MAX_FILTER_JAN_CODE_LENGTH)
        : params.jan_code
  }

  const sort_by = searchParams.get("sort_by")

  if (sort_by) {
    filterParams.sort_by = sort_by

    const sort_direction = searchParams.get("sort_direction")

    if (sort_direction) {
      filterParams.sort_direction = sort_direction as ProductListFilter["sort_direction"]
    } else {
      filterParams.sort_direction = SORT_DIRECTION.ASCEND
    }
  }

  return filterParams
}

export const useProductListParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  return useMemo(() => {
    const params = parseProductListFilter(searchParams)
    const setParams = (newParams: ProductListFilter) => {
      setSearchParams(Object.fromEntries(Object.entries(newParams).map(([key, value]) => [key, String(value)])))
    }

    return [params, setParams] as const
  }, [searchParams, setSearchParams])
}
